$(function () {
	$(".product-item-snippet .titles").matchHeight()

	if ($(".collection-masonry").length > 0) {
		const $masonry = $(".collection-masonry").imagesLoaded(function () {
			$masonry
				.isotope({
					itemSelector: ".masonry-item",
					masonry: {
						columnWidth: ".masonry-sizer",
					},
					percentPosition: true,
					horizontalOrder: false,
					transitionDuration: "0.3s",
				})
				.one("layoutComplete", function (event, laidOutItems) {
					console.log(`Masonry layout has been updated with ${laidOutItems.length} products!`)
				})

			$("button.filters-heading").on("click", function () {
				$(this).toggleClass("collapsed").next().toggle()
			})

			$(".filters-buttons .button-masonry").on("click", function () {
				$(".filters-buttons .button-masonry").removeClass("current")

				$(this).addClass("current")
				$(".collection-masonry").isotope({ filter: $(this).attr("data-filter") })
				$(".button-masonry-clear").fadeIn()
			})

			$(".filters-buttons .button-masonry-clear").on("click", function () {
				$(".collection-masonry").isotope({ filter: $(this).attr("data-filter") })
				$(".filters-buttons .button-masonry").removeClass("current")
				$(this).fadeOut()
			})
			const hashFilterParser = () => {
				const hashTag = window.location.hash.replace("#", ".")
				if (hashTag.includes(".heading-")) {
					$(".button-masonry-clear").fadeIn()
					$(".collection-masonry").isotope({ filter: hashTag })
					$(`.filters-buttons .button-masonry[data-filter="${hashTag}"]`).addClass("current")
				}
			}
			hashFilterParser()
			$(window).on("hashchange", function () {
				$(".filters-buttons .button-masonry").removeClass("current")
				hashFilterParser()
			})
		})
	}

	$("#product-slider").on("init", function (event, slick) {
		$(".image-zoom").zoom({
			magnify: 1.5,
			duration: 60,
			touch: false,
		})
	})
	$("#product-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: "#product-slider-thumbs",
		infinite: false,
	})

	$("#product-slider-thumbs").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: "#product-slider",
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		arrows: true,
		infinite: false,
		prevArrow: '<button type="button" class="slick-prev"><</button>',
		nextArrow: '<button type="button" class="slick-next">></button>',
	})
})
